/* VF Live from the shop — sections/vf_shop-clips.liquid (homepage)
   Strip: every tile starts as a poster. A tile's loop is only fetched (data-src → src) and played while at least
   60% of it is on screen, and paused as soon as it leaves, so a phone never decodes more than the two or three
   clips it can see. Save-Data and reduced motion keep the posters; the player still plays on tap because that
   is the visitor asking for it.
   Player: one shared <dialog> (Esc, focus trap and the backdrop come from the browser) with the clip, its full
   caption and a link to the TikTok post. No TikTok script anywhere. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function autoplayAllowed() {
    return !reduceMotion.matches && !saveData;
  }

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init(root) {
    if (root.dataset.vfScReady) return;
    root.dataset.vfScReady = '1';

    var track = root.querySelector('[data-vf-sc-track]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-vf-sc-open]'));
    var dialog = root.querySelector('[data-vf-sc-player]');
    if (!track || !tiles.length || !dialog) return;

    var playerVideo = dialog.querySelector('[data-vf-sc-player-video]');
    var playerDate = dialog.querySelector('[data-vf-sc-player-date]');
    var playerCaption = dialog.querySelector('[data-vf-sc-player-caption]');
    var playerLink = dialog.querySelector('[data-vf-sc-player-link]');
    var current = -1;
    var opener = null;

    // --- strip autoplay ----------------------------------------------------------------------------------------
    var visible = new Set();

    function startTile(tile) {
      var video = tile.querySelector('video');
      if (!video) return;
      if (!video.src) {
        video.src = video.dataset.src;
        video.addEventListener('playing', function () { tile.classList.add('is-playing'); });
      }
      play(video);
    }

    function stopTile(tile) {
      var video = tile.querySelector('video');
      if (video && video.src) video.pause();
    }

    function syncStrip() {
      var on = autoplayAllowed() && !dialog.open && !document.hidden;
      tiles.forEach(function (tile) {
        if (on && visible.has(tile)) startTile(tile);
        else stopTile(tile);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.6) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        syncStrip();
      }, { threshold: [0, 0.6] });
      tiles.forEach(function (tile) { io.observe(tile); });
    }
    document.addEventListener('visibilitychange', syncStrip);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', syncStrip);

    // --- strip arrows (desktop) --------------------------------------------------------------------------------
    var prev = root.querySelector('[data-vf-sc-prev]');
    var next = root.querySelector('[data-vf-sc-next]');

    function syncArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function page(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    // --- player ------------------------------------------------------------------------------------------------
    /** Caption text with #hashtags in teal; built from text nodes only, so a caption can never inject markup. */
    function renderCaption(text) {
      playerCaption.textContent = '';
      text.split(/(#[^\s#]+)/).forEach(function (part) {
        if (!part) return;
        if (part.charAt(0) === '#') {
          var tag = document.createElement('span');
          tag.className = 'vf-sc__tag';
          tag.textContent = part;
          playerCaption.appendChild(tag);
        } else {
          playerCaption.appendChild(document.createTextNode(part));
        }
      });
    }

    function show(index) {
      current = (index + tiles.length) % tiles.length;
      var tile = tiles[current];
      var caption = tile.parentNode.querySelector('.vf-sc__caption');
      var model = tile.dataset.model;
      playerDate.textContent = tile.dataset.date + (model ? ' · ' + model : '');
      renderCaption(caption ? caption.textContent.trim() : '');
      playerCaption.scrollTop = 0;
      playerLink.href = tile.dataset.url || playerLink.href;
      var poster = tile.querySelector('.vf-sc__poster');
      playerVideo.poster = poster ? poster.currentSrc || poster.src : '';
      playerVideo.src = tile.dataset.video;
      play(playerVideo);
    }

    function open(index, from) {
      opener = from || null;
      show(index);
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('vf-sc-locked');
      syncStrip();
    }

    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function () { open(i, tile); });
    });

    dialog.querySelector('[data-vf-sc-close]').addEventListener('click', function () { dialog.close(); });
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-vf-sc-step]'), function (btn) {
      btn.addEventListener('click', function () { show(current + Number(btn.dataset.vfScStep)); });
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
    });
    // A click on the backdrop lands on the <dialog> element itself.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    // Swipe left/right on the video to step through clips on phones.
    var touchX = null;
    playerVideo.parentNode.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    playerVideo.parentNode.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    dialog.addEventListener('close', function () {
      playerVideo.pause();
      playerVideo.removeAttribute('src');
      playerVideo.load();
      document.documentElement.classList.remove('vf-sc-locked');
      if (opener) opener.focus({ preventScroll: true });
      syncStrip();
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vf-sc]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor re-renders the section in place.
  document.addEventListener('shopify:section:load', boot);
})();
